'use client';

import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import StatusBar from 'src/components/primitives/StatusBar/StatusBar';
import { APP_DOMAIN } from 'src/constants/site';

const EmulationBar = () => {
	const viewingAuthority = useVelocityStore((s) => s.authorityParam);
	const isEmulatingAccount = useVelocityStore((s) => s.isEmulatingAccount);
	const shouldRender = isEmulatingAccount;

	if (!shouldRender) {
		return null;
	}

	const authority = viewingAuthority?.replace('authority=', '');

	return (
		<StatusBar variant="info">
			You are currently viewing {authority}&apos;s wallet. Actions will not
			work. Access {APP_DOMAIN} to connect your own wallet.
		</StatusBar>
	);
};

export default EmulationBar;
